import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']

  // eslint-disable-next-line class-methods-use-this
  changeTab(event) {
    window.tc.utils.classroomPlacementGraphHandleButtonClick(event.params.tabName)
  }
}
